import React from 'react';
import { Box, Inline } from '@styleseat/ui';
import {
  BodyText,
  HeaderText,
  Stack,
} from '../../../../ui';
import type { ProAppointment } from '../../../../../api/Providers/Appointments';

type MessageProps = {
  inCancellationWindow: boolean;
  in24HourCancellationWindow: boolean;
  proLateCancellationFeePercent: number;
  proCanCancel: boolean;
  appointment: ProAppointment;
};

const Message: React.FC<MessageProps> = ({
  inCancellationWindow,
  in24HourCancellationWindow,
  proLateCancellationFeePercent,
  proCanCancel,
  appointment,
}) => {
  const clientFirstName = appointment.client.name.split(' ')[0];
  const cancellationCharge = appointment.cancellation_charge;
  const message = 'What to know:';
  const bullet1 = "Same-day cancellations ruin clients' plans and reduce confidence in our community";
  const bullet2 = 'If you cancel, your search ranking will be negatively impacted';
  const bullet3 = `Only ${clientFirstName} can cancel since it's the day of the appointment`;
  const bullet4 = `If ${clientFirstName} cancels, your search ranking won't be affected`;
  const bullets = [{ key: 1, value: bullet1 }];

  if (in24HourCancellationWindow && inCancellationWindow) {
    bullets.push({ key: 6, value: `If ${clientFirstName} cancels, your search ranking won't be affected` });
    bullets.push({ key: 7, value: `If ${clientFirstName} cancels, they will be charged your Late Cancellation Fee: ${proLateCancellationFeePercent}% ($${cancellationCharge})` });
  } else {
    if (inCancellationWindow && proCanCancel) bullets.push({ key: 2, value: bullet2 });
    if (inCancellationWindow && !proCanCancel) bullets.push({ key: 3, value: bullet3 });
    if (inCancellationWindow) bullets.push({ key: 4, value: bullet4 });
  }
  return (
    <Stack
      space={16}
      paddingX={24}
    >
      <HeaderText
        level="3"
        testID="cancel-appointment-modal-main-message-title-text"
      >
        {message}
      </HeaderText>
      {bullets.map(({ key, value }) => (
        <Inline
          space={8}
          paddingLeft={8}
          key={key}
        >
          <Box
            top={-4}
          >
            <BodyText appearance="large">&bull;</BodyText>
          </Box>
          <BodyText
            weight="thin"
            testID={`cancel-appointment-modal-main-message-bullet${key}-text`}
          >
            {value}
          </BodyText>
        </Inline>
      ))}
    </Stack>
  );
};

export default Message;
